import * as corePixiInit from './core/initializePixi.js'

const loadAndExecuteFunction = (func) => (...args) =>
  corePixiInit.loadGameUIFunctions()
    .then((gameUI) => gameUI[func](...args))
    .catch((error) => {
      console.error(`Error using gameUI.${func}():`, error)
      throw error
    })

const resetPixiGame = loadAndExecuteFunction('resetPixiGame')

const frogJumpAlive = loadAndExecuteFunction('frogJump')
export const birdFlyAnim = loadAndExecuteFunction('birdFlyAnim')
export const flowerShow = loadAndExecuteFunction('flowerShow')
export const setLeafMultipliers = loadAndExecuteFunction('setLeafMultipliers')
export const moveFlagLand = loadAndExecuteFunction('moveFlagLand')
export const nextRound = loadAndExecuteFunction('nextRound')
const lateEntry = loadAndExecuteFunction('lateEntry')

const frogJumpDead = () => {
  birdFlyAnim()
  frogJumpAlive()
}

export const pixiAppResize = (x, y) => {
  corePixiInit.resizePixiApp(x, y)
  resetPixiGame(x, y)
}

export const currencies = {
  dollar: 'texture-name',
  euro: 'texture-name'
}

export const bbCrossApplicationInit = (setIsPixiAssetsLoaded) => corePixiInit.init(setIsPixiAssetsLoaded)

export const bbCrossAssetsLoad = (setIsPixiAssetsLoaded) => corePixiInit.loadPixiAssets(setIsPixiAssetsLoaded)

export const bbCrossApplicationDestroy = () => corePixiInit.destroyPixiApp()

export const frogJump = (isDead) => {
  !isDead ? frogJumpDead() : frogJumpAlive()
}
// export const birdKillFrog = () => birdFlyAnim()
export const unfinishedBets = steps => lateEntry(steps)
export const isSimulate = true

// const moveFrogDiv = document.createElement('button')
// moveFrogDiv.innerHTML = 'move frog'
// moveFrogDiv.onclick = () => frogJump(true)
// document.body.appendChild(moveFrogDiv)

// const nextRoundDiv = document.createElement('button')
// nextRoundDiv.innerHTML = 'Next Round'
// nextRoundDiv.onclick = () => nextRound()
// document.body.appendChild(nextRoundDiv)

// const birdKillFrogDiv = document.createElement('button')
// birdKillFrogDiv.innerHTML = 'Flower'
// birdKillFrogDiv.onclick = () => flowerShow()
// document.body.appendChild(birdKillFrogDiv)

// const birdFlyDiv = document.createElement('button')
// birdFlyDiv.innerHTML = 'bird fly kill'
// birdFlyDiv.onclick = () => birdFlyAnim()
// document.body.appendChild(birdFlyDiv)

// const unfinishedBetsDiv = document.createElement('button')
// unfinishedBetsDiv.innerHTML = 'Unfinished Bets'
// unfinishedBetsDiv.onclick = () => unfinishedBets(5)
// document.body.appendChild(unfinishedBetsDiv)

// const setMultipliersDiv = document.createElement('button')
// setMultipliersDiv.innerHTML = 'Multipliers'
// setMultipliersDiv.onclick = () => setLeafMultipliers(['0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0'])
// document.body.appendChild(setMultipliersDiv)

// const moveFlagLandDiv = document.createElement('button')
// moveFlagLandDiv.innerHTML = 'Move Flag Land'
// moveFlagLandDiv.onclick = () => moveFlagLand(5)
// document.body.appendChild(moveFlagLandDiv)
